// removed by extract-text-webpack-plugin
module.exports = {"loader":"style__loader___1KrdD","error":"style__error___1BIcd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/router-wrapper/style.css
// module id = 205
// module chunks = 0